export const admins = {
  appBarTitle: "Admins",
  list: {
    addNewAdmin: "Add Standard Admin",
    totalStandardAdmins: "Total Standard Admins",
    table: {
      email: "Email",
      status: "Status",
      creationDate: "Creation Date",
      activationDate: "Activation Date",
    },
    status: {
      verification: "Verification",
      regular: "Regular",
    },
    resetPassword: "Reset Password",
    resetAdminPassword: {
      sendResetPassword: "Send Reset Password Email",
      email: "Email",
      emailPlaceholder: "Enter email",
      emailRequired: "Email is required",
      emailValid: "Please enter a valid email",
      confirmMsg: "Are you sure you want to send reset password email?",
    },
  },
  adminsForm: {
    addTitle: "Add Standard Admin",
    email: "Email Address",
    enterEmail: "Enter email address",
    verificationAdmin: "Verification Admin",
    confirmationMsg: "Are you sure you want to add this new admin?",
    validations: {
      emailReq: "Email is required",
      emailValid: "Please enter a valid email",
    },
  },
  messages: {
    adminAdded: "Standard admin was added successfully",
    resetPasswordEmailSent: "Reset password email was sent successfully",
  },
};
